<template>
	<el-form ref="form" :model="form" label-width="95px">
	  <el-row :gutter="20">
	    <slot name="show"></slot>
	    <el-collapse-transition>
	      <div v-show="advanced">
	        <slot name="hide"></slot>
	      </div>
	    </el-collapse-transition>
	    <div class="right-handle-group">
	      <slot name="button"></slot>
	      <a @click="toggleAdvanced">
	        {{ advanced ? '收起' : setText }}
	        <i :class="advanced ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
	      </a>
	    </div>
	  </el-row>
	</el-form>
</template>

<script>
	export default {
    props:{
    	//标签
    	setText:{
    		type:String,
    		default:'展开'
    	}
    },
		data(){
			return {
				form: {
				  name: '',
				  type: '',
				  date: ''
				},
				advanced: false
			}
		},
		methods:{
			toggleAdvanced() {
			  this.advanced = !this.advanced
			}
		}
	}
</script>

<style scoped="scoped">
	.width-full{width: 100%;}
</style>
